"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-danger */
const utils_1 = require("../../utils");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const Message_1 = require("../message/Message");
const react_1 = __importDefault(require("react"));
const transformTemplateString = (string, posaRedeemStore, accountName) => {
    if (!string)
        return '';
    if (!posaRedeemStore)
        return string;
    const { platform, externalAuths, epicAccountName, offer, wallets, psnRegion, secondaryCode: secondaryCodeObj = {} } = posaRedeemStore;
    const platformDisplayName = utils_1.getDisplayNameForPlatform(platform, externalAuths);
    const deviceName = utils_1.getLocalizedPlatformName(platform, Message_1.localizedMessage);
    const cardImage = utils_1.getCardImage(offer);
    const cardBalance = utils_1.getCardValue(offer);
    const accountBalance = utils_1.getBalance(wallets, platform);
    const secondaryCode = secondaryCodeObj.code || '';
    const psnRegionName = Message_1.localizedMessage(`epic.code.redemption.psn.region.${psnRegion}`);
    const transformed = string
        .replace('{epicAccountName}', accountName || epicAccountName || '')
        .replace('{platform}', deviceName)
        .replace('{platformDisplayName}', platformDisplayName)
        .replace('{secondaryCode}', secondaryCode)
        .replace('{psnRegionName}', psnRegionName)
        .replace('{cardBalance}', cardBalance)
        .replace('{cardImage}', cardImage)
        .replace('{accountBalance}', accountBalance);
    return transformed;
};
/**
 * replate template strings with actual values
 */
const PosaTemplate = ({ posaRedeemStore, useDangerouslySetInnerHTML, Tag, className, isTemplate, options, string, accountName }) => {
    const transformed = transformTemplateString(string, posaRedeemStore, accountName);
    if (isTemplate) {
        const reactElement = html_react_parser_1.default(transformed, options);
        if (Tag) {
            return react_1.default.createElement(Tag, { className: className }, reactElement);
        }
        return react_1.default.createElement(react_1.default.Fragment, null, reactElement);
    }
    if (!useDangerouslySetInnerHTML) {
        if (Tag) {
            return react_1.default.createElement(Tag, { className: className }, transformed);
        }
        return react_1.default.createElement(react_1.default.Fragment, null, transformed);
    }
    if (Tag) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Tag, { className: className, dangerouslySetInnerHTML: { __html: transformed } })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: className, dangerouslySetInnerHTML: { __html: transformed } })));
};
exports.default = PosaTemplate;
//# sourceMappingURL=PosaTemplate.js.map